import React, { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Progress from 'components/Progress';
import { templatesPath } from 'routes';
import { asTemplate } from 'transformers/templates';
import Template from 'types/Template';
import { useJsonboxAxios } from 'utils/jsonbox';
import withCollection from 'utils/withCollection';
import { EditTemplate } from 'pages/editTemplate';

const CloneTemplateController: React.FC = () => {
  const { collectionId, id } = useParams<{ collectionId?: string; id?: string }>();
  const navigate = useNavigate();
  const [{ data }, executeGet] = useJsonboxAxios({ method: 'GET' }, { manual: true });

  const [{ loading: postLoading }, executePost] = useJsonboxAxios(
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    },
    { manual: true },
  );

  useEffect(() => {
    if (!collectionId) return;

    executeGet({
      url: `/${collectionId}/${id}`,
    });
  }, [collectionId, id, executeGet]);

  const handleOnCancel = useCallback(() => {
    if (collectionId) {
      navigate(templatesPath(collectionId));
    } else {
      navigate('/');
    }
  }, [navigate, collectionId]);

  if (!collectionId) return null;

  const handleOnSave = async (template: Template) => {
    await executePost({
      url: `/${collectionId}`,
      data: template,
    });

    navigate(templatesPath(collectionId));
  };

  if (data) {
    const template = asTemplate(data);
    template.name = `Copy of ${template.name}`;

    return <EditTemplate template={template} onCancel={handleOnCancel} onSave={handleOnSave} saving={postLoading} />;
  }

  return <Progress />;
};

export default withCollection(CloneTemplateController);
